import { render, staticRenderFns } from "./UserMenuActivator.vue?vue&type=template&id=770f6528&scoped=true&"
import script from "./UserMenuActivator.vue?vue&type=script&lang=js&"
export * from "./UserMenuActivator.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuActivator.vue?vue&type=style&index=0&id=770f6528&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f6528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
